export class GlobalEvents {
    public static CloseAllMenus:string = 'closeAllMenus';
    public static OptionMenuActivated:string = 'OptionMenuActivated';
    public static Cancel_Navigation: string = 'cancel_navigation';
    public static Navegacion_De_Pagina: string = 'navegacion_de_pagina';
    public static Refrescar_Pagina: string = 'refrescar_pagina';
    public static CambiarRutaBreadCrumbs: string = "CambiarRutaBreadCrumbs";
}
